module.exports = __webpack_public_path__ + "SBCR_logo_header_plain.svg?214803540910843a9ae9cbe9e6fddb2d";